import { Stack } from "@altimateai/lego";
import { Typography } from "@altimateai/lego";
import { Icon } from "@tabler/icons-react";

const HeadingWithIcon = ({ icon: IconComponent, title }: { title: string; icon: Icon }) => {
  return (
    <Stack align="center">
      <IconComponent size={24} className="al-bg-bg-brand al-text-brand al-p-1 al-rounded-4" />
      <Typography variant="h4" weight="semibold">{title}</Typography>
    </Stack>
  );
};

export default HeadingWithIcon;
